import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import RemoveLegalEntityPage from 'modules/settings/components/Payroll/LegalEntities/RemoveLegalEntityPage'

const RemovePage = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { id } = useStrictParams<'id'>()

  const onClose = () => {
    navigate(navigation.settings.details.fullPath())
  }

  return <RemoveLegalEntityPage onClose={onClose} legalEntityId={Number(id)} />
}

export default RemovePage
